module.exports = __webpack_public_path__ + "static/img/Nash-King.753985a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Nash-King.jpg
// module id = Jqx6
// module chunks = 0